import { Directive, Input, OnInit, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * Directiva reutilizable para autoplay de sliders/carruseles.
 *
 * Uso:
 * ```html
 * <div [appAutoplay]="nextFn" [autoplayInterval]="5000" [autoplayEnabled]="true">
 * ```
 */
@Directive({
  selector: '[appAutoplay]',
  standalone: true,
})
export class AutoplayDirective implements OnInit, OnDestroy {
  /** Función que se ejecuta en cada tick del intervalo (ej: nextSlide) */
  @Input('appAutoplay') nextFn: (() => void) | null = null;

  /** Intervalo en milisegundos (default: 5000ms) */
  @Input() autoplayInterval: number = 5000;

  /** Permite habilitar/deshabilitar el autoplay */
  @Input() autoplayEnabled: boolean = true;

  private intervalId: ReturnType<typeof setInterval> | null = null;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId) && this.autoplayEnabled) {
      this.start();
    }
  }

  ngOnDestroy(): void {
    this.stop();
  }

  private start(): void {
    if (!this.nextFn) return;
    this.intervalId = setInterval(() => {
      this.nextFn?.();
    }, this.autoplayInterval);
  }

  private stop(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
